import "@babel/polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {unregister as unregisterServiceWorker} from './registerServiceWorker';
import {applyMiddleware, createStore} from 'redux';
import {Provider} from 'react-redux';
import appReducers from './state/reducers';
import thunkMiddleware from 'redux-thunk';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import config from "./config";
import HomePage from "./pages/HomePage";
import ProHomePage from "./pages/ProHomePage";
import ProSignUpPage from "./pages/ProSignUpPage";
import ProFaqPage from "./pages/ProFaqPage";
import BusinessHomePage from "./pages/BusinessHomePage";
import BusinessSignUpPage from "./pages/BusinessSignUpPage";
import BusinessLoginPage from "./pages/BusinessLoginPage";
import BusinessPricingPage from "./pages/BusinessPricingPage";
import BusinessFaqPage from "./pages/BusinessFaqPage";
import CateringHomePage from "./pages/CateringHomePage";
import RestaurantHomePage from "./pages/RestaurantHomePage";
import ContactPage from "./pages/ContactPage";
import BusinessForgotPasswordPage from "./pages/BusinessForgotPasswordPage";
import BusinessPasswordResetPage from "./pages/BusinessPasswordResetPage";
import {MuiThemeProvider} from '@material-ui/core/styles';
import theme from "./theme";
import NotFoundPage from "./pages/NotFoundPage";
import ShiftPageCaterSpot from "./pages/shift-pages/ShiftPageCaterSpot";
import ShiftPageCaterSpot2 from "./pages/shift-pages/ShiftPageCaterSpot2";
import ShiftPageGrain50 from "./pages/shift-pages/ShiftPageGrain50";
import ShiftPageMookata53 from "./pages/shift-pages/ShiftPageMookata53";
import ShiftPageGrain55 from "./pages/shift-pages/ShiftPageGrain55";
import ShiftPageBlackFairy56 from "./pages/shift-pages/ShiftPageBlackFairy56";
import ShiftPageChopHouse58 from "./pages/shift-pages/ShiftPageChopHouse58";
import ShiftPageMookata59 from "./pages/shift-pages/ShiftPageMookata59";
import ShiftPageMookata60 from "./pages/shift-pages/ShiftPageMookata60";
import ShiftPageMookata61 from "./pages/shift-pages/ShiftPageMookata61";
import ShiftPageMookata62 from "./pages/shift-pages/ShiftPageMookata62";
import ShiftPageHaiXianLao64 from "./pages/shift-pages/ShiftPageHaiXianLao64";
import ShiftPageMookata66 from "./pages/shift-pages/ShiftPageMookata66";
import ShiftPagePersonalChef68 from "./pages/shift-pages/ShiftPagePersonalChef68";
import ShiftPageHaiXianLao69 from "./pages/shift-pages/ShiftPageHaiXianLao69";
import ShiftPageHaiXianLao70 from "./pages/shift-pages/ShiftPageHaiXianLao70";
import ShiftPageHaiXianLao82 from "./pages/shift-pages/ShiftPageHaiXianLao82";
import ShiftPageHaiXianLao83 from "./pages/shift-pages/ShiftPageHaiXianLao83";
import ShiftPageFusspot71 from "./pages/shift-pages/ShiftPageFusspot71";
import ShiftPageMookata73 from "./pages/shift-pages/ShiftPageMookata73";
import ShiftPageBenJerry74 from "./pages/shift-pages/ShiftPageBenJerry74";
import ShiftPageBenJerry75 from "./pages/shift-pages/ShiftPageBenJerry75";
import ShiftPageBenJerry76 from "./pages/shift-pages/ShiftPageBenJerry76";
import ShiftPageBurp86 from "./pages/shift-pages/ShiftPageBurp86";
import ShiftPageHaiXianLao87 from "./pages/shift-pages/ShiftPageHaiXianLao87";
import ShiftPageHaiXianLao89 from "./pages/shift-pages/ShiftPageHaiXianLao89";
import ShiftPageBurp90 from "./pages/shift-pages/ShiftPageBurp90";
import ShiftPageFoodieDrools91 from "./pages/shift-pages/ShiftPageFoodieDrools91";
import ShiftPageBuro92 from "./pages/shift-pages/ShiftPageBuro92";
import ShiftPageButcherBoy93 from "./pages/shift-pages/ShiftPageButcherBoy93";
import ShiftPageGoldenGate94 from "./pages/shift-pages/ShiftPageGoldenGate94";
import ShiftPageCaterSpot95 from "./pages/shift-pages/ShiftPageCaterSpot95";
import ShiftPageCaterSpot96 from "./pages/shift-pages/ShiftPageCaterSpot96";
import ShiftPageBlackFairy97 from "./pages/shift-pages/ShiftPageBlackFairy97";
import ShiftPageCaterSpot138 from "./pages/shift-pages/ShiftPageCaterSpot138";
import ShiftPageList from "./pages/shift-pages/ShiftPageList";
import ShiftPage from "./pages/shift-page";
import ShiftListPage from './pages/ShiftListPage';
import {injectGlobal} from 'styled-components';
import fonts from "./styles/fonts";
import {typeSF18r} from "./styles/typefaces";

injectGlobal`
  ${fonts}
  
  html {
    ${typeSF18r};
  }
`;


const store = createStore(appReducers, applyMiddleware(thunkMiddleware));

function init() {
  ReactDOM.render(
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <BrowserRouter>
          <Switch>
            <Route exact path={config.routes.home} component={HomePage}/>
            <Route exact path={config.routes.pros} component={ProHomePage}/>
            <Route exact path={config.routes.prosSignUp} component={ProSignUpPage}/>
            <Route exact path={config.routes.prosFaq} component={ProFaqPage}/>
            <Route exact path={config.routes.business} component={BusinessHomePage}/>
            <Route exact path={config.routes.businessSignUp} component={BusinessSignUpPage}/>
            <Route exact path={config.routes.businessLogin} component={BusinessLoginPage}/>
            <Route exact path={config.routes.businessForgotPassword} component={BusinessForgotPasswordPage}/>
            <Route exact path={config.routes.businessPasswordReset} component={BusinessPasswordResetPage}/>
            <Route exact path={config.routes.notFound} component={NotFoundPage}/>
            <Route exact path={config.routes.businessFaq} component={BusinessFaqPage}/>
            <Route exact path={config.routes.businessPricing} component={BusinessPricingPage}/>
            <Route exact path={config.routes.catering} component={CateringHomePage}/>
            <Route exact path={config.routes.restaurant} component={RestaurantHomePage}/>
            <Route exact path={config.routes.notFound} component={NotFoundPage}/>
            <Route exact path={config.routes.contact} component={ContactPage}/>
            <Route exact path={'/shifts/caterspot'} component={ShiftPageCaterSpot}/>
            <Route exact path={'/shifts/grain-11jul'} component={ShiftPageGrain50}/>
            <Route exact path={'/shifts/fusion-mookata-14jul'} component={ShiftPageMookata53}/>
            <Route exact path={'/shifts/grain-12jul'} component={ShiftPageGrain55}/>
            <Route exact path={'/shifts/blackfairy-18jul'} component={ShiftPageBlackFairy56}/>
            <Route exact path={'/shifts/chophouse-19jul'} component={ShiftPageChopHouse58}/>
            <Route exact path={'/shifts/fusion-mookata-21jul'} component={ShiftPageMookata59}/>
            <Route exact path={'/shifts/fusion-mookata-21jul-2'} component={ShiftPageMookata60}/>
            <Route exact path={'/shifts/fusion-mookata-22jul'} component={ShiftPageMookata61}/>
            <Route exact path={'/shifts/fusion-mookata-11aug'} component={ShiftPageMookata62}/>
            <Route exact path={'/shifts/hai-xian-lao-27jul'} component={ShiftPageHaiXianLao64}/>
            <Route exact path={'/shifts/personal-chef-18aug'} component={ShiftPagePersonalChef68}/>
            <Route exact path={'/shifts/hai-xian-lao-3aug'} component={ShiftPageHaiXianLao69}/>
            <Route exact path={'/shifts/hai-xian-lao-4aug'} component={ShiftPageHaiXianLao70}/>
            <Route exact path={'/shifts/hai-xian-lao-17aug'} component={ShiftPageHaiXianLao82}/>
            <Route exact path={'/shifts/hai-xian-lao-18aug'} component={ShiftPageHaiXianLao83}/>
            <Route exact path={'/shifts/fusspot-8aug'} component={ShiftPageFusspot71}/>
            <Route exact path={'/shifts/fusion-mookata-11aug-2'} component={ShiftPageMookata73}/>
            <Route exact path={'/shifts/ben-jerry-10aug'} component={ShiftPageBenJerry74}/>
            <Route exact path={'/shifts/ben-jerry-11aug'} component={ShiftPageBenJerry75}/>
            <Route exact path={'/shifts/ben-jerry-12aug'} component={ShiftPageBenJerry76}/>
            <Route exact path={'/shifts/hai-xian-lao-17aug'} component={ShiftPageHaiXianLao82}/>
            <Route exact path={'/shifts/hai-xian-lao-18aug'} component={ShiftPageHaiXianLao83}/>
            <Route exact path={'/shifts/caterspot-3sep'} component={ShiftPageCaterSpot2}/>
            <Route exact path={'/shifts/burp-25aug'} component={ShiftPageBurp86}/>
            <Route exact path={'/shifts/hai-xian-lao-25aug'} component={ShiftPageHaiXianLao87}/>
            <Route exact path={'/shifts/hai-xian-lao-1sep'} component={ShiftPageHaiXianLao89}/>
            <Route exact path={'/shifts/burp-31aug'} component={ShiftPageBurp90}/>
            <Route exact path={'/shifts/flavours-of-the-east-10sep'} component={ShiftPageFoodieDrools91}/>
            <Route exact path={'/shifts/buro-1sep'} component={ShiftPageBuro92}/>
            <Route exact path={'/shifts/butcher-boy-5sep'} component={ShiftPageButcherBoy93}/>
            <Route exact path={'/shifts/golden-gate-16sep'} component={ShiftPageGoldenGate94}/>
            <Route exact path={'/shifts/caterspot-8sep-cook'} component={ShiftPageCaterSpot95}/>
            <Route exact path={'/shifts/caterspot-8sep-server'} component={ShiftPageCaterSpot96}/>
            <Route exact path={'/shifts/blackfairy-6sep'} component={ShiftPageBlackFairy97}/>
            <Route exact path={'/shifts/caterspot-1oct'} component={ShiftPageCaterSpot138}/>
            <Route exact path={'/shifts/list'} component={ShiftPageList}/>
            <Route exact path={config.routes.shiftsPage} component={ShiftListPage}/>
            <Route path={config.routes.shiftPage} component={ShiftPage}/>
            <Route component={App}/>
          </Switch>
        </BrowserRouter>
      </MuiThemeProvider>
    </Provider>,
    document.getElementById('root')
  );
}

if (window.Raven) {
  window.Raven.context(function() {
    init();
  });
  console.log("Loaded Raven context");
} else {
  init();
}

unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js